import { observable } from "mobx";
import { Type } from "class-transformer";
import RequestedChargeValidityResponse from "./requestedChargeValidityResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class ChargeValidityInstructionGroupResponse {
  @observable
  @Type(() => RequestedChargeValidityResponse)
  requestedValidity!: RequestedChargeValidityResponse;

  /**
   * Price list item ID.
   */
  @observable
  priceListItemId!: string;

  /**
   * Calculated valid since based on requested validity.
   */
  @observable
  @Type(() => Date)
  validSince!: Date;

  /**
   * Calculated valid until based on requested validity.
   */
  @observable
  @Type(() => Date)
  validUntil!: Date;
}
